(() => {
  document.documentElement.classList.add('besycle-clean-ready');

  const protectFrenchPunctuation = (root = document) => {
    const headings = root.querySelectorAll('h1, h2, h3');
    headings.forEach((heading) => {
      const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        node.nodeValue = node.nodeValue.replace(/[ \t\u00A0\u202F]+([?!:;])/g, '\u00A0$1');
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => protectFrenchPunctuation(), { once: true });
  } else {
    protectFrenchPunctuation();
  }
})();
